module finadai.app.admin.update {
    import ProxyRecord = models.http.responses.ProxyRecord;
    export var NAME = "finadai.app.admin.update";

    function AdminUpdateCustomerController(customersService: services.CustomersService,
                                           whoIAm: models.User, $rootScope, $scope,
                                           notify, confirm, $mdDialog: ng.material.IDialogService,
                                           $state: ng.ui.IStateService, negotiationsService: services.NegotiationsService,
                                           proxifier, $q: ng.IQService, authService: services.AuthService) {
        $scope.formData = {};
        $scope.searchData = {};
        $scope.updatingCustomer = false;
        $scope.searchingCustomer = false;
        $scope.showUpdateForm = false;


        $scope.canUpdateCustomer = whoIAm.operations.indexOf('admin_update_customer') >= 0;
        $scope.searchCustomer = (form) => {
            $scope.showUpdateForm = false;
            if (form.$valid) {
                $scope.searchingCustomer = true;
                customersService.proxyGetCustomer({customer_number: $scope.searchData.customer_number})
                    .then(function (response) {
                        $scope.formData = response.data;
                        $scope.formData = $scope.formData.Data;
                        $scope.formData.FechaNacimiento = moment($scope.formData.FechaNacimiento).toDate();

                        console.log(response.data);
                        $scope.searchingCustomer = false;
                        $scope.showUpdateForm = true;

                    }, function () {
                        notify('No se Encontro Acreditado', 'danger');
                        $scope.showUpdateForm = false;
                        $scope.searchingCustomer = false;
                    })
                    .catch(error => {
                        notify('No se Encontro Acreditado', 'danger');
                        $scope.showUpdateForm = false;
                        $scope.searchingCustomer = false;
                        console.log(error);
                    });
            }
        };
        $scope.ValidarTelefono = () => {
            $scope.updatingCustomer = true;
            if ($scope.formData.TelefonoMovil != "") {
                customersService.proxyValidateCellphone($scope.formData)
                    .then(function (response) {
                        let codigo = response.data.Data.Codigo;
                        notify('SMS Enviado Validar Codigo: ' + codigo, 'success', 25000);
                        $scope.updatingCustomer = false;
                    }, function () {
                        notify('Error en el Servicio', 'danger');
                        $scope.updatingCustomer = false;
                    })
                    .catch(error => {
                        $scope.updatingCustomer = false;
                        console.log(error);
                    });
                $scope.updatingCustomer = false;
            }
        };
        $scope.updateCustomer = (form) => {
            if (form.$valid) {
                $scope.updatingCustomer = true;
                delete $scope.formData.ReferenciaHSBC;
                $scope.formData.NumCliente;
                $scope.formData.rfc = $scope.formData.RFC;
                customersService.proxyUpdateCustomerAdmin($scope.formData)
                    .then(function (response) {
                        notify('Acreditado Actualizado');
                        $scope.updatingCustomer = false;
                        this.updateCustomerForm.reset();
                        $scope.showUpdateForm = false;
                    }, function () {
                        notify('Fallo Actualizar Acreditado', 'danger');
                        $scope.updatingCustomer = false;
                    })
                    .catch(error => {
                        $scope.updatingCustomer = false;
                        console.log(error);
                    });
            }
        }
    }

    export function run() {
        var cancel = angular.module(NAME, [])
        cancel.controller("AdminUpdateCustomerController", AdminUpdateCustomerController)
    }
}
finadai.app.admin.update.run();
